import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FilterStateService {
  private filterState: any = null;
  private scrutinyTable: any[] | null = null;

  setState(state: any) {
    this.filterState = state;
  }

  getState(): any {
    return this.filterState;
  }

  clearState() {
    this.filterState = null;
  }

  setScrutinyTable(data: any[]) {
    this.scrutinyTable = data;
  }

  getScrutinyTable(): any[] | null {
    return this.scrutinyTable;
  }

  clearScrutinyTable() {
    this.scrutinyTable = null;
  }
}
